// @vitejs/plugin-react
import { Routes } from 'react-router-dom';
import { AuthProvider } from '../components/AuthContext';
import { AppRoutes } from './RoutesConfig';
import { routes } from './routes';

const URLs = () => (
  <AuthProvider>
    <Routes>
      {AppRoutes()}
    </Routes>
  </AuthProvider>
);

// Reverse lookup function
export const reverse = (name) => {
  const route = routes.find(route => route.name === name);
  return route ? route.url : '#';
};

export default URLs;